import axios from 'axios';
import { adapterAfterLoginNavigate } from '@/microAdapt/function'
import { router } from '@/router';
import Message from '@/utils/resetMessage';
import { exitSystem } from "@/utils/generalMethods";
import logServeCof from '@/plugins/logServeCof.js';
import { getHomeToken, TokenManager } from '@/utils/tokenManage'


const getToken = (type) => {
    const token = TokenManager.getToken(type);
    return token;
}

// 创建axios实例
const service = axios.create({
    baseURL: `${window.serverUrl}/${logServeCof.logServeCof()}`,
    timeout: window.commonTimeout, // 请求超时时间
})
service.interceptors.request.use((config) => {
    const { tokenType } = config
    config.headers.Authorization = getToken(tokenType);
    return config;
})

service.interceptors.response.use(response => {
    if (response.status == 200) {
        let data = response.data;
        return new Promise(resolve => { resolve(data) });
    }
}, async err => {
    if (err.response.status == 504 || err.response.status == 404) {
        Message.error({ message: '服务器错误，请稍候再试!' });
    } else if (err.response.status == 403) {
        if (err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            Message.error({ message: err.response.data.error.message });
        } else {
            Message.error({ message: '权限不足,请联系管理员!' });
        }
    } else if (err.response.status == 400) {
        if (err.response && err.response.data && err.response.data.error && err.response.data.error.details) {
            Message.error({ message: err.response.data.error.details });
        } else {
            Message.error({ message: '权限不足,请联系管理员!' });
        }
    } else if (err.response.status == 401) {
        const headers = err.response.headers;
        if (headers['token-expired'] && headers['token-expired'].includes('OnlineInvalid')) {
            await Message.error({ message: '当前用户已在其他地方登录!', duration: 5 * 1000 })
        } else {
            await Message.error({ message: '登录信息已过期，请重新登录!', duration: 3 * 1000 })
        }
        adapterAfterLoginNavigate(() => {
            if (window.isCloseTab) {
                exitSystem();
            } else {
                sessionStorage.clear()
                sessionStorage.setItem('loginFlag', false)
                if (window.isPrivate) {
                    router.push('/privateLogin');
                } else {
                    router.push('/login')
                }
                window.location.reload()
            }
        });
    } else {
        Message.error({ message: '未知错误!' });
    }
    return Promise.reject(err);
})

export default service;